module.exports = __webpack_public_path__ + "static/media/noConversation.33698768.png";